<template>
  <div>
    <botton-bar/>
    <div class="content">
      <div class="container mb-3">
        <sound-hint class="mb-3"/>
        <div class="row no-gutters segmented-shell">
          <div class="col-6 px-1">
            <button class="btn btn-status btn-block" :class="{'btn-primary': pesquisa.status === '1'}" @click="selecionarStatus('1')">
              Aguardando <span v-if="nAguardando">({{ nAguardando }})</span>
            </button>
          </div>
          <div class="col-6 px-1">
            <button class="btn btn-status btn-block" :class="{'btn-primary': pesquisa.status === '2'}" @click="selecionarStatus('2')">
              Em Rota <span v-if="nEmRota">({{ nEmRota }})</span>
            </button>
          </div>
        </div>
      </div>
      <loading v-if="load" class="mt-5" text="Por favor aguarde"/>
      <div class="container" v-show="!load">
        <div class="mb-3" v-for="grupo in gruposPedidos" :key="grupo.chave">
          <div class="card card-pedido" tabindex="1">
            <div class="grupo-pedidos__header" v-if="grupo.id_rota !== null">
              <b>Rota #{{ grupo.numero_rota }}</b>
              <span>{{ grupo.pedidos.length }} {{ grupo.pedidos.length === 1 ? 'pedido' : 'pedidos' }}</span>
            </div>
            <div
              class="grupo-pedidos__item"
              v-for="pedido in grupo.pedidos"
              :key="pedido.id_pedido"
            >
              <pedido
                :p="pedido"
                :status="pesquisa.status"
                :pertence-rota="grupo.id_rota !== null"
                @toggleStatus="toggleStatus"
                @openGps="openGps"
                @openPedido="openPedido"
              />
              <div class="grupo-pedidos__acoes" v-if="grupo.id_rota !== null">
                <a href="javascript:" class="grupo-pedidos__ver-mais" @click.stop="openPedido(pedido)">
                  Ver mais
                </a>
                <button
                  class="btn btn-primary btn-auto grupo-pedidos__entregar"
                  v-if="pesquisa.status === '2'"
                  @click.stop="toggleStatus('3', pedido)"
                >
                  Entregar Pedido <i class="fa-solid fa-circle-check ml-1"></i>
                </button>
              </div>
            </div>
            <div class="text-center grupo-pedidos__footer" v-if="pesquisa.status === '1' && grupo.id_rota !== null">
              <a href="javascript:" class="grupo-pedidos__toggle" @click.stop="iniciarRota(grupo)">
                Iniciar Rota <i class="fa-solid fa-location-arrow ml-1"></i>
              </a>
            </div>
            <div class="text-center grupo-pedidos__footer" v-else-if="pesquisa.status === '2' && grupo.id_rota !== null">
              <a href="javascript:" class="grupo-pedidos__toggle" @click.stop="entregarRota(grupo)">
                Entregar Pedidos <i class="fa-solid fa-circle-check ml-1"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="text-center mt-4">
          <div class="pt-4 mb-3 empty-state" v-if="!pedidos.length">
            <img v-show="online === false" src="@/assets/illustrations/semconexao.png" alt="Ilustração de dispositivo sem conexão" class="empty-state__img">
            <img v-show="online && pesquisa.status === '1'" src="@/assets/illustrations/aguardando-sempedidos.png" alt="Ilustração de entregador aguardando pedidos" class="empty-state__img">
            <img v-show="online && pesquisa.status === '2'" src="@/assets/illustrations/emrota-sempedidos.png" alt="Ilustração de entregador em rota" class="empty-state__img">
            <span class="empty-state__title" v-if="online === false">Sem conexão com a internet</span>
            <span class="empty-state__title" v-else-if="pesquisa.status === '1'">Nenhum pedido aguardando entrega</span>
            <span class="empty-state__title" v-else>Não há pedidos em rota de entrega</span>
          </div>
          <div class="empty-state__action">
            <button class="btn btn-outline-primary px-4" :disabled="sincronizando" @click="sincronizarPedidos">
              <i v-if="!sincronizando" class="fa-solid fa-rotate-right mr-1"></i>
              {{ sincronizando ? 'Sincronizando...' : 'Sincronizar' }}
            </button>
            <div class="last-sync" v-if="online && ultimaSincronizacao">
              Atualizado em {{ ultimaSincronizacao }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fixed-bottom ped-bottom">
      <div class="container">
        <div class="row no-gutters" v-if="pesquisa.status === '1'">
          <div class="col-6 pr-1">
            <button class="btn btn-outline-primary btn-block py-3 text-nowrap" @click="openModalAdd()" v-if="pesquisa.status === '1'" :disabled="load">
              <i class="fa-solid fa-plus mr-1"></i> Adicionar Pedido
            </button>
          </div>
          <div class="col-6 pl-1">
            <button class="btn btn-primary btn-block py-3 text-nowrap" @click="confirmarStatus('2')" v-if="pesquisa.status === '1'" :disabled="load">
              Iniciar Entrega <i class="fa-solid fa-location-arrow ml-1"></i>
            </button>
          </div>
        </div>
        <div class="row no-gutters" v-else-if="pesquisa.status === '2'">
          <div class="col-6 pr-1">
            <button class="btn btn-outline-primary btn-block py-3 text-nowrap" @click="gerarRota()" :disabled="load">
              Abrir Mapa <i class="fa-solid fa-map-location-dot ml-1"></i>
            </button>
          </div>
          <div class="col-6 pl-1">
            <button class="btn btn-primary btn-block py-3 text-nowrap" @click="confirmarStatus('3')" :disabled="load">
              Entregar Todos <i class="fa-solid fa-circle-check ml-1"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <modal-bottom :value="modalAdd" title="Adicionar Pedido" @input="handleModalAddInput">
        <form id="form-add-pedido" @submit.prevent="addPedido()" class="sheet-form">
          <div class="form-group mb-2">
            <label class="small font-weight-bold mb-0">Número do Pedido</label>
            <input type="tel" id="nPedido" class="form-control" v-model="dados.id_contador" placeholder="Ex: 123" required>
          </div>
          <div class="form-group">
            <label class="small font-weight-bold mb-0">Empresa</label>
            <select class="form-control sheet-select" v-model="dados.id_empresa">
              <option v-for="e in empresas" :value="e.id_empresa">{{e.nome_fantasia}}</option>
            </select>
          </div>
        </form>
      <template #footer>
        <button type="button" class="btn btn-outline-primary" @click="closeModalAdd">Voltar</button>
        <button type="submit" form="form-add-pedido" class="btn btn-secondary" :disabled="load">Adicionar</button>
      </template>
    </modal-bottom>

    <info-pedido ref="infoPedido" @openGps="openGps"/>

    <modal-bottom v-model="modalColeta" title="Confirmar Entrega">
        <div class="text-center">
          <p>Entregue o pedido somente após confirmar o código.</p>
          <div class="alert alert-primary coleta-alert">PEDIDO #{{coleta.id_contador}}</div>
        </div>
        <form id="form-confirmar-coleta" @submit.prevent="confirmarColeta()" class="sheet-form">
          <div class="d-flex align-items-center">
            <input type="tel" id="nCode" class="form-control mr-2" v-model="coleta.codigo" placeholder="####" minlength="4" maxlength="4" required>
          </div>
        </form>
      <template #footer>
        <button type="button" class="btn btn-outline-primary" :disabled="load" @click="toggleStatus('3', coleta, true)">Entregar sem confirmar</button>
        <button type="submit" form="form-confirmar-coleta" class="btn btn-secondary" :disabled="load">Confirmar</button>
      </template>
    </modal-bottom>
  </div>
</template>

<script>
  import BottonBar from "../components/BottonBar";
  import Loading from "@/components/Loading";
  import Pedido from "@/components/Pedido";
  import InfoPedido from "@/views/InfoPedido";
  import ModalBottom from "@/components/ModalBottom";
  import SoundHint from '@/components/SoundHint';
  import { readPedidosCache, writePedidosCache } from '@/services/pedidosCache';

  const ORIGENS_COM_CODIGO_ENTREGA = ['6', '11'];
  const exigeCodigoEntrega = origin => ORIGENS_COM_CODIGO_ENTREGA.includes(String(origin));

  const normalizarIdsPedidos = pedidosIds => new Set(
    (Array.isArray(pedidosIds) ? pedidosIds : []).map(String)
  );

  const removerPedidosPorIds = (pedidos, pedidosIds) => {
    const ids = normalizarIdsPedidos(pedidosIds);
    return pedidos.filter(pedido => !ids.has(String(pedido.id_pedido)));
  };

  export default {
    name: 'Pedidos',
    components: {SoundHint, ModalBottom, InfoPedido, Pedido, Loading, BottonBar},
    data() {
      return {
        token: localStorage.getItem('key'),
        load: false,
        pesquisa: { status: '1' },
        pedidos: [],
        pedidosAtivos: [],
        pedidosRequestId: 0,
        sincronizadoEm: null,
        sincronizando: false,
        selecionados: [],
        interval: null,
        modalAdd: false,
        modalAddNavigationPushed: false,
        modalColeta: false,
        dados: { id_contador: '', id_empresa: '' },
        nAguardando: 0,
        nEmRota: 0,
        aguardando: 0,
        coleta: { id_pedido: null, codigo: '' }
      }
    },

    methods: {
      loopPedidos(hasCache = false) {
        clearInterval(this.interval);
        this.getPedidos(hasCache);

        this.interval = setInterval(() => {
          this.getPedidos(true);
        }, 1000 * 60 * 3);
      },

      sincronizarPedidos() {
        if (this.sincronizando) return;

        this.sincronizando = true;
        const request = this.getPedidos(true);

        if (!request) {
          this.sincronizando = false;
          return;
        }

        request.then(sincronizado => {
          this.sincronizando = false;

          if (sincronizado) {
            this.$swal('Pedidos sincronizados com sucesso!');
          }
        });
      },

      setAguardandoCount(value) {
        this.nAguardando = Math.max(0, value || 0);

        if (this.nAguardando) {
          window.document.title = `(${this.nAguardando}) LeCard Entregador`;
        } else {
          window.document.title = `LeCard Entregador`;
        }
      },

      setEmRotaCount(value) {
        this.nEmRota = Math.max(0, value || 0);
      },

      selecionarStatus(status) {
        this.pesquisa.status = status;
        this.selecionados = [];
        this.pedidos = this.normalizePedidos(
          this.pedidosAtivos.filter(pedido => String(pedido.status_entrega) === status)
        );
      },

      atualizarSnapshot(pedidos) {
        this.pedidosAtivos = pedidos;
        this.aguardando = pedidos.filter(pedido => String(pedido.status_entrega) === '1');
        this.setAguardandoCount(this.aguardando.length);
        this.setEmRotaCount(
          pedidos.filter(pedido => String(pedido.status_entrega) === '2').length
        );
        this.selecionarStatus(this.pesquisa.status);
      },

      carregarCache() {
        const cache = readPedidosCache(this.empresa.id_usuario);
        if (!cache) return false;

        this.sincronizadoEm = cache.sincronizado_em || null;
        this.atualizarSnapshot(cache.pedidos);
        return true;
      },

      salvarCache() {
        writePedidosCache({
          idEntregador: this.empresa.id_usuario,
          pedidos: this.pedidosAtivos,
          sincronizadoEm: this.sincronizadoEm
        });
      },

      applyImmediateCounterUpdate(fromStatus, toStatus, pedidosIds) {
        const ids = normalizarIdsPedidos(pedidosIds);
        const movedCount = ids.size;

        if (!movedCount) {
          return;
        }

        if (fromStatus === '1') {
          this.setAguardandoCount(this.nAguardando - movedCount);
          this.aguardando = (this.aguardando || []).filter(
            pedido => !ids.has(String(pedido.id_pedido))
          );
        }

        if (fromStatus === '2') {
          this.setEmRotaCount(this.nEmRota - movedCount);
        }

        if (toStatus === '2') {
          this.setEmRotaCount(this.nEmRota + movedCount);
        }

        this.pedidosAtivos = this.pedidosAtivos
          .map(pedido => ids.has(String(pedido.id_pedido))
            ? { ...pedido, status_entrega: toStatus }
            : pedido)
          .filter(pedido => String(pedido.status_entrega) !== '3');
        this.salvarCache();
      },

      getPedidos(background = false) {
        if (this.load) {
          return;
        }

        const requestId = ++this.pedidosRequestId;

        if (!background) {
          this.load = true;
          this.selecionados = [];
          this.pedidos = [];
        }
        return this.$http.get('v2/entregador/pedidos')
          .then(response => {
            if (requestId !== this.pedidosRequestId) return false;

            this.load = false;
            const payload = response.data || {};
            const pedidos = payload.pedidos || [];
            this.sincronizadoEm = payload.sincronizado_em || null;
            this.atualizarSnapshot(pedidos);
            this.salvarCache();

            if (this.nAguardando && this.canPlay) this.tocarAlerta();

            return true;
          }, () => {
            if (requestId !== this.pedidosRequestId) return false;
            this.load = false;
            return false;
          });
      },

      async tocarAlerta() {
        const sincronizados = JSON.parse(sessionStorage.getItem('sincronizados') || '[]');
        const idsAtuais = (this.aguardando || []).map(p => p.id_pedido);
        const naoSync = idsAtuais.some(id => !sincronizados.includes(id));

        if (naoSync && this.canPlay) {
          const played = await this.playNotification();
          if (played) sessionStorage.setItem('sincronizados', JSON.stringify(idsAtuais));
        }
      },

      normalizePedidos(pedidos) {
        return pedidos.slice();
      },

      agruparPedidos(pedidos) {
        const grupos = [];
        const rotas = new Map();

        pedidos.forEach(pedido => {
          const possuiRota = pedido.id_rota !== null
            && pedido.id_rota !== undefined
            && pedido.id_rota !== '';

          if (!possuiRota) {
            grupos.push({
              chave: `pedido-${pedido.id_pedido}`,
              id_rota: null,
              pedidos: [pedido]
            });
            return;
          }

          const chaveRota = String(pedido.id_rota);
          let grupo = rotas.get(chaveRota);

          if (!grupo) {
            grupo = {
              chave: `rota-${chaveRota}`,
              id_rota: pedido.id_rota,
              numero_rota: pedido.numero_rota,
              pedidos: []
            };
            rotas.set(chaveRota, grupo);
            grupos.push(grupo);
          }

          grupo.pedidos.push(pedido);
        });

        grupos.forEach(grupo => {
          if (grupo.id_rota === null) return;

          grupo.pedidos.sort((a, b) => {
            const ordemA = Number.parseInt(a.ordem_entrega, 10);
            const ordemB = Number.parseInt(b.ordem_entrega, 10);
            const valorA = Number.isNaN(ordemA) ? Number.MAX_SAFE_INTEGER : ordemA;
            const valorB = Number.isNaN(ordemB) ? Number.MAX_SAFE_INTEGER : ordemB;

            return valorA - valorB;
          });
        });

        return grupos;
      },

      clearPesquisa(status) {
        this.dados.id_contador = '';
        this.nAguardando = 0;
        this.aguardando = [];
        this.selecionados = [];
        this.selecionarStatus(status || '1');
        this.getPedidos();
      },

      openModalAdd() {
        this.dados.id_contador = '';
        this.modalAddNavigationPushed = true;
        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: { ...this.$route.query, modal: 'add-pedido' }
        });
      },

      handleModalAddInput(opened) {
        if (!opened) this.closeModalAdd();
      },

      closeModalAdd() {
        this.modalAdd = false;

        if (this.$route.query.modal !== 'add-pedido') return;

        if (this.modalAddNavigationPushed) {
          this.modalAddNavigationPushed = false;
          this.$router.back();
          return;
        }

        const query = { ...this.$route.query };
        delete query.modal;
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query
        });
      },

      closeModal() {
        if (this.modalAdd || this.$route.query.modal === 'add-pedido') {
          this.closeModalAdd();
        }
        this.modalColeta = false;
      },

      addPedido() {
        this.closeModal();
        this.load = true;

        const assumirPedidoPayload = {
          id_empresa: Number(this.dados.id_empresa),
          id_contador: Number(this.dados.id_contador)
        };

        this.$http.post('v2/entregador/pedidos/assumir', assumirPedidoPayload)
          .then(response => {
            this.load = false;

            if (response.data && response.data.success) {
              this.clearPesquisa();

            } else {
              this.$swal((response.data || {}).msg || 'Erro temporário');
            }

          }, response => {
            this.load = false;
            this.$swal((response.data || {}).msg || 'Erro temporário');
          });
      },

      openModalColeta() {
        this.modalColeta = true;
        this.$nextTick(() => {
          this.$helpers.focusElement('nCode');
        })
      },

      confirmarColeta() {
        if (this.coleta.codigo.length !== 4) {
          return;
        }

        this.closeModal();
        this.load = true;

        const coletaPayload = {
          id_pedido: this.coleta.id_pedido,
          delivery_code: this.coleta.codigo
        };

        this.$http.post('v2/entregador/coleta', coletaPayload)
          .then(response => {
            this.load = false;

            if (!response.data || !response.data.success) {
              this.$swal('Verifique o código de confirmação e tente novamente.');

            } else {
              this.$swal("Pedido confirmado com sucesso.");
              this.pedidos = this.pedidos.filter(p => p.id_pedido !== this.coleta.id_pedido);
              this.applyImmediateCounterUpdate('2', '3', [this.coleta.id_pedido]);
              this.coleta = { id_pedido: null, codigo: '' }
              this.selecionados = [];

              if (!this.pedidos.length) {
                this.selecionarStatus('1');
              }
            }

          }, response => {
            this.load = false;
            const mensagem = response.data && response.data.msg
              ? 'Verifique o código de confirmação e tente novamente.'
              : 'Não foi possível confirmar a entrega. Tente novamente.';
            this.$swal(mensagem);
          });
      },

      openGps(selecionado) {
        const e = selecionado;
        const destination = (e.lat_endereco && e.long_endereco) ? `${e.lat_endereco},${e.long_endereco}`
            : encodeURI(`${e.logradouro}, ${e.numero || ''}, ${this.empresa.nome_cidade} - ${this.empresa.sigla_estado}`);

        if (this.navegacao === 2 && e.lat_endereco && e.long_endereco) {
          const url = `https://waze.com/ul?ll=${destination}&navigate=yes`;
          window.open(url, '_blank');

        } else {
          const url = `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=driving`;

          if (this.navegacao === 2) {
            this.$swal("Este endereço não tem coordenadas, por isso vai ser aberto no Google Maps.");

          } else {
            window.open(url, '_blank');
          }
        }
      },

      openPedido(pedido) {
        this.$refs.infoPedido.openPedido(pedido);
      },

      confirmarStatus(status) {
        if (!this.pedidos.length) {
          this.$swal('Você não possui pedidos com o status ' + (status === '2' ? "'Aguardando'" : "'Em Rota'") + ' no momento.');
          return;
        }

        const text = (status === '2') ? 'Confirmar início da Entrega dos Pedidos?' : 'Marcar todos como Entregues?';
        const buttons = (status === '2') ? ["Cancelar", "Iniciar Entrega"] : ["Cancelar", "Entregar Todos"];

        this.$swal({text, buttons,
        }).then((r) => {
          if (r) {
            this.editarStatus(status, true);
          }
        });
      },

      iniciarRota(grupo) {
        if (!grupo || grupo.id_rota === null || !grupo.pedidos.length) {
          return;
        }

        this.$swal({
          title: `Rota #${grupo.numero_rota}`,
          text: grupo.pedidos.length === 1
            ? 'Iniciar a entrega do pedido desta rota?'
            : `Iniciar a entrega dos ${grupo.pedidos.length} pedidos desta rota?`,
          buttons: ["Voltar", "Iniciar Rota"]
        }).then(confirmado => {
          if (!confirmado) return;

          const dados = {
            status: 2,
            id_rota: Number(grupo.id_rota)
          };

          this.load = true;
          this.$http.post('v2/entregador/pedidos/status', dados)
            .then(response => {
              this.load = false;

              if (!response.data || !response.data.success) {
                return;
              }

              const pedidosAtualizados = response.data.pedidos || [];
              this.applyImmediateCounterUpdate('1', '2', pedidosAtualizados);
              this.pedidos = removerPedidosPorIds(this.pedidos, pedidosAtualizados);

              if (!this.pedidos.length) {
                this.selecionarStatus('2');
              }
            }, res => {
              this.load = false;
              this.getPedidos(true);
              const fallbackMessage = !res.status
                ? 'Não foi possível iniciar a rota. Verifique sua conexão com a internet e tente novamente.'
                : 'Não foi possível iniciar a rota. Tente novamente.';
              this.$swal((res.data || {}).msg || fallbackMessage);
            });
        });
      },

      entregarRota(grupo) {
        if (!grupo || grupo.id_rota === null || !grupo.pedidos.length) {
          return;
        }

        this.$swal({
          title: `Rota #${grupo.numero_rota}`,
          text: grupo.pedidos.length === 1
            ? 'Marcar o pedido desta rota como entregue?'
            : `Marcar os ${grupo.pedidos.length} pedidos desta rota como entregues?`,
          buttons: ["Voltar", "Entregar Pedidos"],
          dangerMode: true
        }).then(confirmado => {
          if (!confirmado) return;

          this.selecionados = grupo.pedidos.map(pedido => ({ id_pedido: pedido.id_pedido }));
          this.editarStatus('3');
        });
      },

      editarStatus(status, todos) {
        const fromStatus = this.pesquisa.status;
        const dados = { status: Number(status) };

        if (todos) {
          dados.pedidos = this.pedidos.map(p => Number(p.id_pedido));

        } else {
          dados.pedidos = this.selecionados.map(p => Number(p.id_pedido));
        }

        this.load = true;
        this.$http.post('v2/entregador/pedidos/status', dados)
          .then(response => {
            this.load = false;

            if (!response.data || !response.data.success) {
              return;
            }

            const pedidosAtualizados = response.data.pedidos || [];
            this.applyImmediateCounterUpdate(fromStatus, status, pedidosAtualizados);
            this.pedidos = removerPedidosPorIds(this.pedidos, pedidosAtualizados);

            if (!todos) {
              this.selecionados = [];
            }

            if (!this.pedidos.length) {
              if (status === '3') {
                this.selecionarStatus('1');
              } else {
                this.selecionarStatus('2');
              }
            }

          }, res => {
            this.load = false;
            this.getPedidos(true);
            const fallbackMessage = !res.status
              ? 'Não foi possível atualizar o pedido. Verifique sua conexão com a internet e tente novamente.'
              : 'Não foi possível atualizar o pedido. Tente novamente.';
            this.$swal((res.data || {}).msg || fallbackMessage);
          });
      },

      gerarRota(clear) {
        if (!this.pedidos.length) {
          this.$swal('Não há nenhum pedido em rota');
          return;
        }

        const empresa = `${this.empresa.lat_empresa},${this.empresa.long_empresa}`;
        let url = `https://www.google.com/maps/dir/?api=1&destination=${empresa}&travelmode=driving&waypoints=`;

        this.pedidos.forEach(e => {
          if (e.lat_endereco && e.long_endereco) {
            url += `${e.lat_endereco},${e.long_endereco}|`;

          } else {
            url += encodeURI(`${e.logradouro}, ${e.numero || ''}, ${this.empresa.nome_cidade} - ${this.empresa.sigla_estado}`) + '|';
          }
        });

        window.open(url, '_blank');

        if (clear) {
          this.clearPesquisa('2');
        }
      },

      toggleStatus(status, pedido, modal) {
        if (!pedido) {
          return;
        }

        if (modal) {
          this.closeModal();
        }

        if (status === '3' && exigeCodigoEntrega(pedido.origin)) {
          this.coleta = { id_pedido: pedido.id_pedido, id_contador: pedido.id_contador, codigo: '' };
          this.openModalColeta();

        } else {
          const text = status === '2' ? `Iniciar entrega deste pedido?` : `Marcar como entregue?`;
          this.$swal({
            title: `Pedido #${pedido.id_contador}`,
            text,
            buttons: ["Voltar", "Confirmar"],
            dangerMode: true
          }).then((res => {
            if (res) {
              this.selecionados = [{ id_pedido: pedido.id_pedido }];
              this.editarStatus(status);
            }
          }));
        }
      }
    },

    mounted() {
      this.dados.id_empresa = this.empresas[0].id_empresa;
      this.loopPedidos(this.carregarCache());
    },

    computed: {
      empresa() {
        return this.$store.state.user;
      },

      empresas() {
        return this.$store.state.empresas;
      },

      canPlay() {
        return this.$store.state.canPlay;
      },

      navegacao() {
        return this.$store.state.navegacao;
      },

      gruposPedidos() {
        return this.agruparPedidos(this.pedidos);
      },

      online() {
        return this.$store.state.online;
      },

      ultimaSincronizacao() {
        if (!this.sincronizadoEm) return '';

        const date = this.$dayjs(this.sincronizadoEm);
        return date.isValid() ? date.format('DD/MM/YYYY [às] HH:mm') : '';
      }
    },

    watch: {
      '$route.query.modal': {
        immediate: true,
        handler(modal) {
          if (modal === 'add-pedido') {
            this.dados.id_contador = '';
            this.modalAdd = true;
            this.$nextTick(() => {
              this.$helpers.focusElement('nPedido');
            });
            return;
          }

          this.modalAdd = false;
          this.modalAddNavigationPushed = false;
        }
      },

      online(val) {
        if (val) {
          this.getPedidos(true);
        }
      },

      canPlay(val) {
        if (val) {
          this.tocarAlerta();
        }
      }
    },

    sockets: {
      sync_orders() {
        this.getPedidos(true);
      }
    },

    beforeDestroy() {
      clearInterval(this.interval);
    }
  }
</script>
<style scoped>
.ped-bottom {
  --ped-safe-bottom: var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px));
  background-color: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  padding: 0;
  border-top: none;
  box-shadow: none;
}

.dark-mode .ped-bottom {
  background-color: transparent;
}

.ios_platform .ped-bottom {
  --ped-safe-bottom: var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px));
}

.ped-bottom::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(-1 * var(--ped-safe-bottom));
  height: var(--ped-safe-bottom);
  background-color: inherit;
}

.ped-bottom .container {
  padding: 18px 16px calc(20px + var(--ped-safe-bottom));
  border-radius: 28px 28px 0 0;
  background-color: var(--bg-theme-secondary);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: none;
  outline: none;
  box-shadow: 0 -5px 16px rgba(22, 24, 22, 0.05);
}

.dark-mode .ped-bottom .container {
  background-color: var(--bg-theme-secondary);
  box-shadow: 0 -5px 18px rgba(0, 0, 0, 0.30);
}

.ped-bottom .btn-outline-primary {
  border-color: var(--border-strong) !important;
  border-width: 1.5px;
}

.ped-bottom .btn-primary,
.ped-bottom .btn-primary:hover,
.ped-bottom .btn-primary:focus,
.ped-bottom .btn-primary:active {
  box-shadow: none !important;
}

.dark-mode .ped-bottom .btn-outline-primary {
  background-color: rgba(255, 255, 255, 0.02);
  border-color: rgba(255, 255, 255, 0.14) !important;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.dark-mode .ped-bottom .btn-outline-primary:hover {
  background-color: rgba(255, 255, 255, 0.04) !important;
  border-color: rgba(255, 255, 255, 0.22) !important;
}

.card-pedido {
  padding: 18px 18px 0;
  border: 1px solid var(--border-color);
  cursor: pointer;
  border-radius: 28px;
}

.grupo-pedidos__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -2px 0 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color);
}

.grupo-pedidos__header span {
  color: var(--text-muted);
  font-size: 0.82rem;
}

.grupo-pedidos__item + .grupo-pedidos__item {
  margin-top: 16px;
  padding-top: 16px;
}

.grupo-pedidos__acoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
}

.grupo-pedidos__ver-mais {
  color: var(--primary);
  font-size: 0.82rem;
  font-weight: 600;
}

.grupo-pedidos__entregar {
  width: auto;
  min-height: 34px;
  padding: 6px 12px;
  border-radius: 17px;
  font-size: 0.82rem;
  line-height: 1rem;
}

.grupo-pedidos__footer {
  margin-top: 32px;
  margin-bottom: 6px;
  padding-top: 5px;
  border-top: 1px solid var(--border-color);
}

.grupo-pedidos__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 0 6px;
  color: var(--text-default);
  font-weight: 600;
}

.last-sync {
  margin-top: 8px;
  color: var(--text-muted);
  font-size: 0.8rem;
  text-align: center;
}

.segmented-shell {
  margin: 0 -4px 20px;
  padding: 6px;
  border-radius: 26px;
  background-color: var(--secondary);
  border: 1px solid var(--border-color);
}

.btn-status {
  margin: 0;
  min-height: 50px;
  border: 1px solid transparent;
  color: var(--text-muted);
  position: relative;
  white-space: nowrap;
  background-color: transparent;
  box-shadow: none;
}

.btn-status:hover {
  background-color: rgba(255, 255, 255, 0.35);
  color: var(--text-default);
}

.btn-status.btn-primary {
  color: var(--text-on-primary);
}

.empty-state {
  max-width: 420px;
  margin: 0 auto;
  padding: 0 18px 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  color: var(--text-muted);
  transform: translateY(-10px);
}

.empty-state__img {
  width: min(100%, 228px);
  height: auto;
  margin-bottom: 6px;
}

.empty-state__title {
  max-width: 280px;
  font-size: 1rem;
  line-height: 1.28rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-default);
}

.empty-state__action {
  margin-bottom: 84px;
  margin-top: 16px;
}

.empty-state__action .btn {
  min-width: 220px;
  min-height: 50px;
}

.sheet-form .btn-block {
  width: 100%;
}

.sheet-select {
  line-height: 1.35;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  padding-right: 3rem;
  text-overflow: ellipsis;
}

.ios_platform .sheet-select {
  min-height: 58px;
  line-height: 1.25;
  background-position: right 1rem center;
}

.coleta-alert {
  background-color: rgba(199, 244, 123, 0.2);
  border-color: rgba(199, 244, 123, 0.28);
  color: var(--text-default);
}

</style>
